import Alert from "@mui/material/Alert";
import { styled } from "@mui/material/styles";

export enum SnackSeverity {
  SUCCESS = "success",
  ERROR = "error",
}

export const RegistrationAlert = styled(Alert)({
  width: "100%",
});
